import { retrievePersistentData } from '@smart-tv/utils/persistent-data/persistent-data';
import { isSafari } from './is-safari/is-safari';
import { IS_WEBOS } from './is-webos';
import retrieveDeviceId from './device-id-generation';

export const getModelOfDevicePlaying = (): string => {
  const isTizen = Boolean(window.tizen && window.tizen.application);

  if (!isTizen && !IS_WEBOS) {
    return isSafari() ? 'Safari' : 'browser';
  }

  const defaultTvModel = isTizen ? 'Samsung TV' : 'LG TV';

  try {
    const modelValue = retrievePersistentData<string>('tv_model');
    return typeof modelValue === 'string' && modelValue ? modelValue : defaultTvModel;
  } catch (error) {
    console.error('Error retrieving model from localStorage:', error);
    return defaultTvModel;
  }
};

export const getUid = (): string => retrieveDeviceId();
